import script from "./CheckboxgroupCheckbox.vue?vue&type=script&lang=js"
export * from "./CheckboxgroupCheckbox.vue?vue&type=script&lang=js"

import "./CheckboxgroupCheckbox.vue?vue&type=style&index=0&id=a520274e&lang=scss"

const __exports__ = script;

export default __exports__